export const MAIN_MENU_PREFIX = '@@mainMenu';



// WEBPACK FOOTER //
// ./src/js/app/redux/state.js